// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*, ::before, ::after {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}

::backdrop {
  --tw-border-spacing-x: 0;
  --tw-border-spacing-y: 0;
  --tw-translate-x: 0;
  --tw-translate-y: 0;
  --tw-rotate: 0;
  --tw-skew-x: 0;
  --tw-skew-y: 0;
  --tw-scale-x: 1;
  --tw-scale-y: 1;
  --tw-pan-x:  ;
  --tw-pan-y:  ;
  --tw-pinch-zoom:  ;
  --tw-scroll-snap-strictness: proximity;
  --tw-gradient-from-position:  ;
  --tw-gradient-via-position:  ;
  --tw-gradient-to-position:  ;
  --tw-ordinal:  ;
  --tw-slashed-zero:  ;
  --tw-numeric-figure:  ;
  --tw-numeric-spacing:  ;
  --tw-numeric-fraction:  ;
  --tw-ring-inset:  ;
  --tw-ring-offset-width: 0px;
  --tw-ring-offset-color: #fff;
  --tw-ring-color: rgb(59 130 246 / 0.5);
  --tw-ring-offset-shadow: 0 0 #0000;
  --tw-ring-shadow: 0 0 #0000;
  --tw-shadow: 0 0 #0000;
  --tw-shadow-colored: 0 0 #0000;
  --tw-blur:  ;
  --tw-brightness:  ;
  --tw-contrast:  ;
  --tw-grayscale:  ;
  --tw-hue-rotate:  ;
  --tw-invert:  ;
  --tw-saturate:  ;
  --tw-sepia:  ;
  --tw-drop-shadow:  ;
  --tw-backdrop-blur:  ;
  --tw-backdrop-brightness:  ;
  --tw-backdrop-contrast:  ;
  --tw-backdrop-grayscale:  ;
  --tw-backdrop-hue-rotate:  ;
  --tw-backdrop-invert:  ;
  --tw-backdrop-opacity:  ;
  --tw-backdrop-saturate:  ;
  --tw-backdrop-sepia:  ;
  --tw-contain-size:  ;
  --tw-contain-layout:  ;
  --tw-contain-paint:  ;
  --tw-contain-style:  ;
}/*
! tailwindcss v3.4.19 | MIT License | https://tailwindcss.com
*//*
1. Prevent padding and border from affecting element width. (https://github.com/mozdevs/cssremedy/issues/4)
2. Allow adding a border to an element by just adding a border-width. (https://github.com/tailwindcss/tailwindcss/pull/116)
*/

*,
::before,
::after {
  box-sizing: border-box; /* 1 */
  border-width: 0; /* 2 */
  border-style: solid; /* 2 */
  border-color: #e5e7eb; /* 2 */
}

::before,
::after {
  --tw-content: '';
}

/*
1. Use a consistent sensible line-height in all browsers.
2. Prevent adjustments of font size after orientation changes in iOS.
3. Use a more readable tab size.
4. Use the user's configured \`sans\` font-family by default.
5. Use the user's configured \`sans\` font-feature-settings by default.
6. Use the user's configured \`sans\` font-variation-settings by default.
7. Disable tap highlights on iOS
*/

html,
:host {
  line-height: 1.5; /* 1 */
  -webkit-text-size-adjust: 100%; /* 2 */
  -moz-tab-size: 4; /* 3 */
  -o-tab-size: 4;
     tab-size: 4; /* 3 */
  font-family: Instrument Sans, Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, sans-serif; /* 4 */
  font-feature-settings: normal; /* 5 */
  font-variation-settings: normal; /* 6 */
  -webkit-tap-highlight-color: transparent; /* 7 */
}

/*
1. Remove the margin in all browsers.
2. Inherit line-height from \`html\` so users can set them as a class directly on the \`html\` element.
*/

body {
  margin: 0; /* 1 */
  line-height: inherit; /* 2 */
}

/*
1. Add the correct height in Firefox.
2. Correct the inheritance of border color in Firefox. (https://bugzilla.mozilla.org/show_bug.cgi?id=190655)
3. Ensure horizontal rules are visible by default.
*/

hr {
  height: 0; /* 1 */
  color: inherit; /* 2 */
  border-top-width: 1px; /* 3 */
}

/*
Add the correct text decoration in Chrome, Edge, and Safari.
*/

abbr:where([title]) {
  -webkit-text-decoration: underline dotted;
          text-decoration: underline dotted;
}

/*
Remove the default font size and weight for headings.
*/

h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: inherit;
  font-weight: inherit;
}

/*
Reset links to optimize for opt-in styling instead of opt-out.
*/

a {
  color: inherit;
  text-decoration: inherit;
}

/*
Add the correct font weight in Edge and Safari.
*/

b,
strong {
  font-weight: bolder;
}

/*
1. Use the user's configured \`mono\` font-family by default.
2. Use the user's configured \`mono\` font-feature-settings by default.
3. Use the user's configured \`mono\` font-variation-settings by default.
4. Correct the odd \`em\` font sizing in all browsers.
*/

code,
kbd,
samp,
pre {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace; /* 1 */
  font-feature-settings: normal; /* 2 */
  font-variation-settings: normal; /* 3 */
  font-size: 1em; /* 4 */
}

/*
Add the correct font size in all browsers.
*/

small {
  font-size: 80%;
}

/*
Prevent \`sub\` and \`sup\` elements from affecting the line height in all browsers.
*/

sub,
sup {
  font-size: 75%;
  line-height: 0;
  position: relative;
  vertical-align: baseline;
}

sub {
  bottom: -0.25em;
}

sup {
  top: -0.5em;
}

/*
1. Remove text indentation from table contents in Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=999088, https://bugs.webkit.org/show_bug.cgi?id=201297)
2. Correct table border color inheritance in all Chrome and Safari. (https://bugs.chromium.org/p/chromium/issues/detail?id=935729, https://bugs.webkit.org/show_bug.cgi?id=195016)
3. Remove gaps between table borders by default.
*/

table {
  text-indent: 0; /* 1 */
  border-color: inherit; /* 2 */
  border-collapse: collapse; /* 3 */
}

/*
1. Change the font styles in all browsers.
2. Remove the margin in Firefox and Safari.
3. Remove default padding in all browsers.
*/

button,
input,
optgroup,
select,
textarea {
  font-family: inherit; /* 1 */
  font-feature-settings: inherit; /* 1 */
  font-variation-settings: inherit; /* 1 */
  font-size: 100%; /* 1 */
  font-weight: inherit; /* 1 */
  line-height: inherit; /* 1 */
  letter-spacing: inherit; /* 1 */
  color: inherit; /* 1 */
  margin: 0; /* 2 */
  padding: 0; /* 3 */
}

/*
Remove the inheritance of text transform in Edge and Firefox.
*/

button,
select {
  text-transform: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Remove default button styles.
*/

button,
input:where([type='button']),
input:where([type='reset']),
input:where([type='submit']) {
  -webkit-appearance: button; /* 1 */
  background-color: transparent; /* 2 */
  background-image: none; /* 2 */
}

/*
Use the modern Firefox focus style for all focusable elements.
*/

:-moz-focusring {
  outline: auto;
}

/*
Remove the additional \`:invalid\` styles in Firefox. (https://github.com/mozilla/gecko-dev/blob/2f9eacd9d3d995c937b4251a5557d95d494c9be1/layout/style/res/forms.css#L728-L737)
*/

:-moz-ui-invalid {
  box-shadow: none;
}

/*
Add the correct vertical alignment in Chrome and Firefox.
*/

progress {
  vertical-align: baseline;
}

/*
Correct the cursor style of increment and decrement buttons in Safari.
*/

::-webkit-inner-spin-button,
::-webkit-outer-spin-button {
  height: auto;
}

/*
1. Correct the odd appearance in Chrome and Safari.
2. Correct the outline style in Safari.
*/

[type='search'] {
  -webkit-appearance: textfield; /* 1 */
  outline-offset: -2px; /* 2 */
}

/*
Remove the inner padding in Chrome and Safari on macOS.
*/

::-webkit-search-decoration {
  -webkit-appearance: none;
}

/*
1. Correct the inability to style clickable types in iOS and Safari.
2. Change font properties to \`inherit\` in Safari.
*/

::-webkit-file-upload-button {
  -webkit-appearance: button; /* 1 */
  font: inherit; /* 2 */
}

/*
Add the correct display in Chrome and Safari.
*/

summary {
  display: list-item;
}

/*
Removes the default spacing and border for appropriate elements.
*/

blockquote,
dl,
dd,
h1,
h2,
h3,
h4,
h5,
h6,
hr,
figure,
p,
pre {
  margin: 0;
}

fieldset {
  margin: 0;
  padding: 0;
}

legend {
  padding: 0;
}

ol,
ul,
menu {
  list-style: none;
  margin: 0;
  padding: 0;
}

/*
Reset default styling for dialogs.
*/
dialog {
  padding: 0;
}

/*
Prevent resizing textareas horizontally by default.
*/

textarea {
  resize: vertical;
}

/*
1. Reset the default placeholder opacity in Firefox. (https://github.com/tailwindlabs/tailwindcss/issues/3300)
2. Set the default placeholder color to the user's configured gray 400 color.
*/

input::-moz-placeholder, textarea::-moz-placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

input::placeholder,
textarea::placeholder {
  opacity: 1; /* 1 */
  color: #9ca3af; /* 2 */
}

/*
Set the default cursor for buttons.
*/

button,
[role="button"] {
  cursor: pointer;
}

/*
Make sure disabled buttons don't get the pointer cursor.
*/
:disabled {
  cursor: default;
}

/*
1. Make replaced elements \`display: block\` by default. (https://github.com/mozdevs/cssremedy/issues/14)
2. Add \`vertical-align: middle\` to align replaced elements more sensibly by default. (https://github.com/jensimmons/cssremedy/issues/14#issuecomment-634934210)
   This can trigger a poorly considered lint error in some tools but is included by design.
*/

img,
svg,
video,
canvas,
audio,
iframe,
embed,
object {
  display: block; /* 1 */
  vertical-align: middle; /* 2 */
}

/*
Constrain images and videos to the parent width and preserve their intrinsic aspect ratio. (https://github.com/mozdevs/cssremedy/issues/14)
*/

img,
video {
  max-width: 100%;
  height: auto;
}

/* Make elements with the HTML hidden attribute stay hidden by default */
[hidden]:where(:not([hidden="until-found"])) {
  display: none;
}
.\\!container {
  width: 100% !important;
}
.container {
  width: 100%;
}
@media (min-width: 640px) {

  .\\!container {
    max-width: 640px !important;
  }

  .container {
    max-width: 640px;
  }
}
@media (min-width: 768px) {

  .\\!container {
    max-width: 768px !important;
  }

  .container {
    max-width: 768px;
  }
}
@media (min-width: 1024px) {

  .\\!container {
    max-width: 1024px !important;
  }

  .container {
    max-width: 1024px;
  }
}
@media (min-width: 1280px) {

  .\\!container {
    max-width: 1280px !important;
  }

  .container {
    max-width: 1280px;
  }
}
@media (min-width: 1536px) {

  .\\!container {
    max-width: 1536px !important;
  }

  .container {
    max-width: 1536px;
  }
}
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border-width: 0;
}
.visible {
  visibility: visible;
}
.invisible {
  visibility: hidden;
}
.static {
  position: static;
}
.fixed {
  position: fixed;
}
.absolute {
  position: absolute;
}
.relative {
  position: relative;
}
.inset-0 {
  inset: 0px;
}
.inset-y-0 {
  top: 0px;
  bottom: 0px;
}
.left-0 {
  left: 0px;
}
.left-3 {
  left: 0.75rem;
}
.right-2 {
  right: 0.5rem;
}
.top-2 {
  top: 0.5rem;
}
.top-3 {
  top: 0.75rem;
}
.z-40 {
  z-index: 40;
}
.z-50 {
  z-index: 50;
}
.-mr-1 {
  margin-right: -0.25rem;
}
.mb-1 {
  margin-bottom: 0.25rem;
}
.mb-2 {
  margin-bottom: 0.5rem;
}
.mb-3 {
  margin-bottom: 0.75rem;
}
.mb-4 {
  margin-bottom: 1rem;
}
.mb-5 {
  margin-bottom: 1.25rem;
}
.mb-6 {
  margin-bottom: 1.5rem;
}
.mb-8 {
  margin-bottom: 2rem;
}
.ml-1 {
  margin-left: 0.25rem;
}
.ml-2 {
  margin-left: 0.5rem;
}
.ml-3 {
  margin-left: 0.75rem;
}
.ml-auto {
  margin-left: auto;
}
.mr-2 {
  margin-right: 0.5rem;
}
.mr-3 {
  margin-right: 0.75rem;
}
.mt-0\\.5 {
  margin-top: 0.125rem;
}
.mt-1 {
  margin-top: 0.25rem;
}
.mt-2 {
  margin-top: 0.5rem;
}
.mt-3 {
  margin-top: 0.75rem;
}
.mt-4 {
  margin-top: 1rem;
}
.mt-5 {
  margin-top: 1.25rem;
}
.mt-6 {
  margin-top: 1.5rem;
}
.mt-auto {
  margin-top: auto;
}
.line-clamp-2 {
  overflow: hidden;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
.block {
  display: block;
}
.inline-block {
  display: inline-block;
}
.inline {
  display: inline;
}
.flex {
  display: flex;
}
.inline-flex {
  display: inline-flex;
}
.table {
  display: table;
}
.grid {
  display: grid;
}
.hidden {
  display: none;
}
.h-10 {
  height: 2.5rem;
}
.h-11 {
  height: 2.75rem;
}
.h-12 {
  height: 3rem;
}
.h-2 {
  height: 0.5rem;
}
.h-2\\.5 {
  height: 0.625rem;
}
.h-4 {
  height: 1rem;
}
.h-44 {
  height: 11rem;
}
.h-48 {
  height: 12rem;
}
.h-5 {
  height: 1.25rem;
}
.h-56 {
  height: 14rem;
}
.h-6 {
  height: 1.5rem;
}
.h-64 {
  height: 16rem;
}
.h-7 {
  height: 1.75rem;
}
.h-8 {
  height: 2rem;
}
.h-\\[320px\\] {
  height: 320px;
}
.h-full {
  height: 100%;
}
.h-px {
  height: 1px;
}
.h-screen {
  height: 100vh;
}
.max-h-40 {
  max-height: 10rem;
}
.max-h-56 {
  max-height: 14rem;
}
.max-h-72 {
  max-height: 18rem;
}
.max-h-\\[90vh\\] {
  max-height: 90vh;
}
.min-h-0 {
  min-height: 0px;
}
.min-h-\\[500px\\] {
  min-height: 500px;
}
.min-h-\\[650px\\] {
  min-height: 650px;
}
.min-h-screen {
  min-height: 100vh;
}
.w-10 {
  width: 2.5rem;
}
.w-11 {
  width: 2.75rem;
}
.w-12 {
  width: 3rem;
}
.w-2 {
  width: 0.5rem;
}
.w-2\\.5 {
  width: 0.625rem;
}
.w-24 {
  width: 6rem;
}
.w-28 {
  width: 7rem;
}
.w-32 {
  width: 8rem;
}
.w-4 {
  width: 1rem;
}
.w-40 {
  width: 10rem;
}
.w-5 {
  width: 1.25rem;
}
.w-56 {
  width: 14rem;
}
.w-6 {
  width: 1.5rem;
}
.w-7 {
  width: 1.75rem;
}
.w-72 {
  width: 18rem;
}
.w-\\[86vw\\] {
  width: 86vw;
}
.w-full {
  width: 100%;
}
.min-w-0 {
  min-width: 0px;
}
.min-w-\\[1\\.25rem\\] {
  min-width: 1.25rem;
}
.min-w-\\[680px\\] {
  min-width: 680px;
}
.min-w-\\[720px\\] {
  min-width: 720px;
}
.min-w-\\[820px\\] {
  min-width: 820px;
}
.min-w-\\[860px\\] {
  min-width: 860px;
}
.min-w-full {
  min-width: 100%;
}
.max-w-72 {
  max-width: 18rem;
}
.max-w-\\[18rem\\] {
  max-width: 18rem;
}
.max-w-\\[78\\%\\] {
  max-width: 78%;
}
.max-w-lg {
  max-width: 32rem;
}
.max-w-md {
  max-width: 28rem;
}
.max-w-xs {
  max-width: 20rem;
}
.flex-1 {
  flex: 1 1 0%;
}
.flex-shrink-0 {
  flex-shrink: 0;
}
.shrink-0 {
  flex-shrink: 0;
}
.grow {
  flex-grow: 1;
}
.-translate-x-full {
  --tw-translate-x: -100%;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
.translate-x-0 {
  --tw-translate-x: 0px;
  transform: translate(var(--tw-translate-x), var(--tw-translate-y)) rotate(var(--tw-rotate)) skewX(var(--tw-skew-x)) skewY(var(--tw-skew-y)) scaleX(var(--tw-scale-x)) scaleY(var(--tw-scale-y));
}
@keyframes ping {

  75%, 100% {
    transform: scale(2);
    opacity: 0;
  }
}
.animate-ping {
  animation: ping 1s cubic-bezier(0, 0, 0.2, 1) infinite;
}
@keyframes pulse {

  50% {
    opacity: .5;
  }
}
.animate-pulse {
  animation: pulse 2s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}
@keyframes spin {

  to {
    transform: rotate(360deg);
  }
}
.animate-spin {
  animation: spin 1s linear infinite;
}
.cursor-pointer {
  cursor: pointer;
}
.list-disc {
  list-style-type: disc;
}
.grid-cols-1 {
  grid-template-columns: repeat(1, minmax(0, 1fr));
}
.grid-cols-2 {
  grid-template-columns: repeat(2, minmax(0, 1fr));
}
.flex-col {
  flex-direction: column;
}
.flex-wrap {
  flex-wrap: wrap;
}
.items-start {
  align-items: flex-start;
}
.items-end {
  align-items: flex-end;
}
.items-center {
  align-items: center;
}
.items-stretch {
  align-items: stretch;
}
.justify-start {
  justify-content: flex-start;
}
.justify-end {
  justify-content: flex-end;
}
.justify-center {
  justify-content: center;
}
.justify-between {
  justify-content: space-between;
}
.gap-1 {
  gap: 0.25rem;
}
.gap-2 {
  gap: 0.5rem;
}
.gap-3 {
  gap: 0.75rem;
}
.gap-4 {
  gap: 1rem;
}
.gap-6 {
  gap: 1.5rem;
}
.gap-x-6 {
  -moz-column-gap: 1.5rem;
       column-gap: 1.5rem;
}
.gap-y-2 {
  row-gap: 0.5rem;
}
.gap-y-3 {
  row-gap: 0.75rem;
}
.space-y-1 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.25rem * var(--tw-space-y-reverse));
}
.space-y-2 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.5rem * var(--tw-space-y-reverse));
}
.space-y-3 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(0.75rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(0.75rem * var(--tw-space-y-reverse));
}
.space-y-4 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1rem * var(--tw-space-y-reverse));
}
.space-y-5 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.25rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.25rem * var(--tw-space-y-reverse));
}
.space-y-6 > :not([hidden]) ~ :not([hidden]) {
  --tw-space-y-reverse: 0;
  margin-top: calc(1.5rem * calc(1 - var(--tw-space-y-reverse)));
  margin-bottom: calc(1.5rem * var(--tw-space-y-reverse));
}
.divide-y > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-y-reverse: 0;
  border-top-width: calc(1px * calc(1 - var(--tw-divide-y-reverse)));
  border-bottom-width: calc(1px * var(--tw-divide-y-reverse));
}
.divide-zinc-100 > :not([hidden]) ~ :not([hidden]) {
  --tw-divide-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-divide-opacity, 1));
}
.overflow-auto {
  overflow: auto;
}
.overflow-hidden {
  overflow: hidden;
}
.overflow-x-auto {
  overflow-x: auto;
}
.overflow-y-auto {
  overflow-y: auto;
}
.truncate {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.whitespace-nowrap {
  white-space: nowrap;
}
.whitespace-pre-wrap {
  white-space: pre-wrap;
}
.break-all {
  word-break: break-all;
}
.rounded {
  border-radius: 0.25rem;
}
.rounded-2xl {
  border-radius: 1rem;
}
.rounded-3xl {
  border-radius: 1.5rem;
}
.rounded-full {
  border-radius: 9999px;
}
.rounded-lg {
  border-radius: 0.5rem;
}
.rounded-md {
  border-radius: 0.375rem;
}
.rounded-xl {
  border-radius: 0.75rem;
}
.border {
  border-width: 1px;
}
.border-b {
  border-bottom-width: 1px;
}
.border-t {
  border-top-width: 1px;
}
.border-dashed {
  border-style: dashed;
}
.border-amber-200 {
  --tw-border-opacity: 1;
  border-color: rgb(253 230 138 / var(--tw-border-opacity, 1));
}
.border-emerald-200 {
  --tw-border-opacity: 1;
  border-color: rgb(167 243 208 / var(--tw-border-opacity, 1));
}
.border-emerald-500\\/30 {
  border-color: rgb(16 185 129 / 0.3);
}
.border-red-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 202 202 / var(--tw-border-opacity, 1));
}
.border-red-300 {
  --tw-border-opacity: 1;
  border-color: rgb(252 165 165 / var(--tw-border-opacity, 1));
}
.border-red-500\\/30 {
  border-color: rgb(239 68 68 / 0.3);
}
.border-rose-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 205 211 / var(--tw-border-opacity, 1));
}
.border-yellow-200 {
  --tw-border-opacity: 1;
  border-color: rgb(254 240 138 / var(--tw-border-opacity, 1));
}
.border-yellow-300 {
  --tw-border-opacity: 1;
  border-color: rgb(253 224 71 / var(--tw-border-opacity, 1));
}
.border-zinc-100 {
  --tw-border-opacity: 1;
  border-color: rgb(244 244 245 / var(--tw-border-opacity, 1));
}
.border-zinc-200 {
  --tw-border-opacity: 1;
  border-color: rgb(228 228 231 / var(--tw-border-opacity, 1));
}
.border-zinc-300 {
  --tw-border-opacity: 1;
  border-color: rgb(212 212 216 / var(--tw-border-opacity, 1));
}
.border-zinc-700 {
  --tw-border-opacity: 1;
  border-color: rgb(63 63 70 / var(--tw-border-opacity, 1));
}
.border-zinc-800 {
  --tw-border-opacity: 1;
  border-color: rgb(39 39 42 / var(--tw-border-opacity, 1));
}
.border-zinc-900 {
  --tw-border-opacity: 1;
  border-color: rgb(24 24 27 / var(--tw-border-opacity, 1));
}
.border-zinc-950 {
  --tw-border-opacity: 1;
  border-color: rgb(9 9 11 / var(--tw-border-opacity, 1));
}
.bg-amber-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 243 199 / var(--tw-bg-opacity, 1));
}
.bg-amber-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 251 235 / var(--tw-bg-opacity, 1));
}
.bg-amber-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(245 158 11 / var(--tw-bg-opacity, 1));
}
.bg-amber-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(217 119 6 / var(--tw-bg-opacity, 1));
}
.bg-black\\/30 {
  background-color: rgb(0 0 0 / 0.3);
}
.bg-black\\/40 {
  background-color: rgb(0 0 0 / 0.4);
}
.bg-blue-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(239 246 255 / var(--tw-bg-opacity, 1));
}
.bg-emerald-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(209 250 229 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(236 253 245 / var(--tw-bg-opacity, 1));
}
.bg-emerald-50\\/80 {
  background-color: rgb(236 253 245 / 0.8);
}
.bg-emerald-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(16 185 129 / var(--tw-bg-opacity, 1));
}
.bg-emerald-500\\/10 {
  background-color: rgb(16 185 129 / 0.1);
}
.bg-emerald-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(5 150 105 / var(--tw-bg-opacity, 1));
}
.bg-indigo-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(238 242 255 / var(--tw-bg-opacity, 1));
}
.bg-orange-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 247 237 / var(--tw-bg-opacity, 1));
}
.bg-pink-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(253 242 248 / var(--tw-bg-opacity, 1));
}
.bg-purple-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 245 255 / var(--tw-bg-opacity, 1));
}
.bg-red-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 242 242 / var(--tw-bg-opacity, 1));
}
.bg-red-500\\/10 {
  background-color: rgb(239 68 68 / 0.1);
}
.bg-rose-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(255 241 242 / var(--tw-bg-opacity, 1));
}
.bg-rose-50\\/60 {
  background-color: rgb(255 241 242 / 0.6);
}
.bg-rose-500 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 63 94 / var(--tw-bg-opacity, 1));
}
.bg-sky-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(240 249 255 / var(--tw-bg-opacity, 1));
}
.bg-white {
  --tw-bg-opacity: 1;
  background-color: rgb(255 255 255 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(254 252 232 / var(--tw-bg-opacity, 1));
}
.bg-yellow-50\\/60 {
  background-color: rgb(254 252 232 / 0.6);
}
.bg-yellow-600 {
  --tw-bg-opacity: 1;
  background-color: rgb(202 138 4 / var(--tw-bg-opacity, 1));
}
.bg-zinc-100 {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.bg-zinc-400 {
  --tw-bg-opacity: 1;
  background-color: rgb(161 161 170 / var(--tw-bg-opacity, 1));
}
.bg-zinc-50 {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.bg-zinc-800 {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}
.bg-zinc-900 {
  --tw-bg-opacity: 1;
  background-color: rgb(24 24 27 / var(--tw-bg-opacity, 1));
}
.bg-zinc-950 {
  --tw-bg-opacity: 1;
  background-color: rgb(9 9 11 / var(--tw-bg-opacity, 1));
}
.bg-zinc-950\\/55 {
  background-color: rgb(9 9 11 / 0.55);
}
.object-contain {
  -o-object-fit: contain;
     object-fit: contain;
}
.object-cover {
  -o-object-fit: cover;
     object-fit: cover;
}
.p-0 {
  padding: 0px;
}
.p-0\\.5 {
  padding: 0.125rem;
}
.p-1 {
  padding: 0.25rem;
}
.p-1\\.5 {
  padding: 0.375rem;
}
.p-2 {
  padding: 0.5rem;
}
.p-3 {
  padding: 0.75rem;
}
.p-4 {
  padding: 1rem;
}
.p-5 {
  padding: 1.25rem;
}
.p-6 {
  padding: 1.5rem;
}
.p-8 {
  padding: 2rem;
}
.\\!px-3 {
  padding-left: 0.75rem !important;
  padding-right: 0.75rem !important;
}
.\\!py-1\\.5 {
  padding-top: 0.375rem !important;
  padding-bottom: 0.375rem !important;
}
.px-1\\.5 {
  padding-left: 0.375rem;
  padding-right: 0.375rem;
}
.px-2 {
  padding-left: 0.5rem;
  padding-right: 0.5rem;
}
.px-2\\.5 {
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
.px-3 {
  padding-left: 0.75rem;
  padding-right: 0.75rem;
}
.px-4 {
  padding-left: 1rem;
  padding-right: 1rem;
}
.px-5 {
  padding-left: 1.25rem;
  padding-right: 1.25rem;
}
.py-0\\.5 {
  padding-top: 0.125rem;
  padding-bottom: 0.125rem;
}
.py-1 {
  padding-top: 0.25rem;
  padding-bottom: 0.25rem;
}
.py-1\\.5 {
  padding-top: 0.375rem;
  padding-bottom: 0.375rem;
}
.py-2 {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}
.py-2\\.5 {
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
}
.py-3 {
  padding-top: 0.75rem;
  padding-bottom: 0.75rem;
}
.py-4 {
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.py-6 {
  padding-top: 1.5rem;
  padding-bottom: 1.5rem;
}
.pb-2 {
  padding-bottom: 0.5rem;
}
.pl-10 {
  padding-left: 2.5rem;
}
.pl-3 {
  padding-left: 0.75rem;
}
.pl-5 {
  padding-left: 1.25rem;
}
.pr-1 {
  padding-right: 0.25rem;
}
.pr-3 {
  padding-right: 0.75rem;
}
.pr-4 {
  padding-right: 1rem;
}
.pt-3 {
  padding-top: 0.75rem;
}
.pt-4 {
  padding-top: 1rem;
}
.text-left {
  text-align: left;
}
.text-center {
  text-align: center;
}
.text-right {
  text-align: right;
}
.font-mono {
  font-family: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, "Liberation Mono", "Courier New", monospace;
}
.font-sans {
  font-family: Instrument Sans, Inter, ui-sans-serif, system-ui, -apple-system, Segoe UI, Roboto, sans-serif;
}
.\\!text-xs {
  font-size: 0.75rem !important;
  line-height: 1rem !important;
}
.text-2xl {
  font-size: 1.5rem;
  line-height: 2rem;
}
.text-3xl {
  font-size: 1.875rem;
  line-height: 2.25rem;
}
.text-\\[10px\\] {
  font-size: 10px;
}
.text-\\[11px\\] {
  font-size: 11px;
}
.text-base {
  font-size: 1rem;
  line-height: 1.5rem;
}
.text-lg {
  font-size: 1.125rem;
  line-height: 1.75rem;
}
.text-sm {
  font-size: 0.875rem;
  line-height: 1.25rem;
}
.text-xl {
  font-size: 1.25rem;
  line-height: 1.75rem;
}
.text-xs {
  font-size: 0.75rem;
  line-height: 1rem;
}
.font-bold {
  font-weight: 700;
}
.font-medium {
  font-weight: 500;
}
.font-semibold {
  font-weight: 600;
}
.uppercase {
  text-transform: uppercase;
}
.lowercase {
  text-transform: lowercase;
}
.capitalize {
  text-transform: capitalize;
}
.italic {
  font-style: italic;
}
.tabular-nums {
  --tw-numeric-spacing: tabular-nums;
  font-variant-numeric: var(--tw-ordinal) var(--tw-slashed-zero) var(--tw-numeric-figure) var(--tw-numeric-spacing) var(--tw-numeric-fraction);
}
.leading-5 {
  line-height: 1.25rem;
}
.tracking-\\[0\\.18em\\] {
  letter-spacing: 0.18em;
}
.tracking-wide {
  letter-spacing: 0.025em;
}
.tracking-wider {
  letter-spacing: 0.05em;
}
.tracking-widest {
  letter-spacing: 0.1em;
}
.text-amber-300 {
  --tw-text-opacity: 1;
  color: rgb(252 211 77 / var(--tw-text-opacity, 1));
}
.text-amber-600 {
  --tw-text-opacity: 1;
  color: rgb(217 119 6 / var(--tw-text-opacity, 1));
}
.text-amber-700 {
  --tw-text-opacity: 1;
  color: rgb(180 83 9 / var(--tw-text-opacity, 1));
}
.text-amber-800 {
  --tw-text-opacity: 1;
  color: rgb(146 64 14 / var(--tw-text-opacity, 1));
}
.text-amber-900 {
  --tw-text-opacity: 1;
  color: rgb(120 53 15 / var(--tw-text-opacity, 1));
}
.text-blue-600 {
  --tw-text-opacity: 1;
  color: rgb(37 99 235 / var(--tw-text-opacity, 1));
}
.text-blue-700 {
  --tw-text-opacity: 1;
  color: rgb(29 78 216 / var(--tw-text-opacity, 1));
}
.text-emerald-200 {
  --tw-text-opacity: 1;
  color: rgb(167 243 208 / var(--tw-text-opacity, 1));
}
.text-emerald-600 {
  --tw-text-opacity: 1;
  color: rgb(5 150 105 / var(--tw-text-opacity, 1));
}
.text-emerald-700 {
  --tw-text-opacity: 1;
  color: rgb(4 120 87 / var(--tw-text-opacity, 1));
}
.text-emerald-800 {
  --tw-text-opacity: 1;
  color: rgb(6 95 70 / var(--tw-text-opacity, 1));
}
.text-emerald-900 {
  --tw-text-opacity: 1;
  color: rgb(6 78 59 / var(--tw-text-opacity, 1));
}
.text-red-300 {
  --tw-text-opacity: 1;
  color: rgb(252 165 165 / var(--tw-text-opacity, 1));
}
.text-red-600 {
  --tw-text-opacity: 1;
  color: rgb(220 38 38 / var(--tw-text-opacity, 1));
}
.text-red-700 {
  --tw-text-opacity: 1;
  color: rgb(185 28 28 / var(--tw-text-opacity, 1));
}
.text-red-800 {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.text-rose-900 {
  --tw-text-opacity: 1;
  color: rgb(136 19 55 / var(--tw-text-opacity, 1));
}
.text-white {
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity, 1));
}
.text-yellow-700 {
  --tw-text-opacity: 1;
  color: rgb(161 98 7 / var(--tw-text-opacity, 1));
}
.text-yellow-800 {
  --tw-text-opacity: 1;
  color: rgb(133 77 14 / var(--tw-text-opacity, 1));
}
.text-yellow-900 {
  --tw-text-opacity: 1;
  color: rgb(113 63 18 / var(--tw-text-opacity, 1));
}
.text-zinc-200 {
  --tw-text-opacity: 1;
  color: rgb(228 228 231 / var(--tw-text-opacity, 1));
}
.text-zinc-300 {
  --tw-text-opacity: 1;
  color: rgb(212 212 216 / var(--tw-text-opacity, 1));
}
.text-zinc-400 {
  --tw-text-opacity: 1;
  color: rgb(161 161 170 / var(--tw-text-opacity, 1));
}
.text-zinc-500 {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.text-zinc-600 {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.text-zinc-700 {
  --tw-text-opacity: 1;
  color: rgb(63 63 70 / var(--tw-text-opacity, 1));
}
.text-zinc-800 {
  --tw-text-opacity: 1;
  color: rgb(39 39 42 / var(--tw-text-opacity, 1));
}
.text-zinc-900 {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.text-zinc-950 {
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity, 1));
}
.underline {
  text-decoration-line: underline;
}
.line-through {
  text-decoration-line: line-through;
}
.opacity-75 {
  opacity: 0.75;
}
.opacity-80 {
  opacity: 0.8;
}
.shadow-2xl {
  --tw-shadow: 0 25px 50px -12px rgb(0 0 0 / 0.25);
  --tw-shadow-colored: 0 25px 50px -12px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-sm {
  --tw-shadow: 0 1px 2px 0 rgb(0 0 0 / 0.05);
  --tw-shadow-colored: 0 1px 2px 0 var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.shadow-xl {
  --tw-shadow: 0 20px 25px -5px rgb(0 0 0 / 0.1), 0 8px 10px -6px rgb(0 0 0 / 0.1);
  --tw-shadow-colored: 0 20px 25px -5px var(--tw-shadow-color), 0 8px 10px -6px var(--tw-shadow-color);
  box-shadow: var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow);
}
.outline-none {
  outline: 2px solid transparent;
  outline-offset: 2px;
}
.outline {
  outline-style: solid;
}
.ring {
  --tw-ring-offset-shadow: var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);
  --tw-ring-shadow: var(--tw-ring-inset) 0 0 0 calc(3px + var(--tw-ring-offset-width)) var(--tw-ring-color);
  box-shadow: var(--tw-ring-offset-shadow), var(--tw-ring-shadow), var(--tw-shadow, 0 0 #0000);
}
.filter {
  filter: var(--tw-blur) var(--tw-brightness) var(--tw-contrast) var(--tw-grayscale) var(--tw-hue-rotate) var(--tw-invert) var(--tw-saturate) var(--tw-sepia) var(--tw-drop-shadow);
}
.backdrop-blur-sm {
  --tw-backdrop-blur: blur(4px);
  backdrop-filter: var(--tw-backdrop-blur) var(--tw-backdrop-brightness) var(--tw-backdrop-contrast) var(--tw-backdrop-grayscale) var(--tw-backdrop-hue-rotate) var(--tw-backdrop-invert) var(--tw-backdrop-opacity) var(--tw-backdrop-saturate) var(--tw-backdrop-sepia);
}
.transition {
  transition-property: color, background-color, border-color, text-decoration-color, fill, stroke, opacity, box-shadow, transform, filter, backdrop-filter;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.transition-transform {
  transition-property: transform;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}
.duration-200 {
  transition-duration: 200ms;
}

html,
body,
#root {
  height: 100%;
}

body {
  font-family: "Instrument Sans", "Inter", ui-sans-serif, system-ui, -apple-system,
    "Segoe UI", Roboto, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Sidebar unread-chat badge attention pulse — faster than tailwind's
   animate-pulse so it reads as urgent rather than ambient. */
@keyframes pulse-fast {
  0%, 100% {
    opacity: 1;
    transform: scale(1);
  }
  50% {
    opacity: 0.6;
    transform: scale(1.08);
  }
}

.animate-pulse-fast {
  animation: pulse-fast 1.1s cubic-bezier(0.4, 0, 0.6, 1) infinite;
}

/* ── Slice F — Office of General Counsel ("Legal Journal") ───────────
 * Scoped to \`.legal-journal\` so the editorial palette (paper / ink /
 * classified red / counsel green / brass) doesn't leak into the rest
 * of the admin portal. Serif headers, monospace labels, dossier cards
 * with a rubber stamp. WCAG-AA: all foreground colors verified ≥ 4.5:1
 * against the paper background.
 */
.legal-journal {
  --paper: #f5f1e8;
  --paper-edge: #ece6d4;
  --surface: #fffef9;
  --surface-laid: #fbf6e9;
  --ink: #0a0a0a;
  --ink-soft: #1f1f1f;
  --ink-mute: #3d3d3d;
  --ink-faint: #5a5648;
  --rule: #1a1a1a;
  --rule-soft: rgba(42, 42, 42, 0.2);
  --classified: #8b0000;
  --counsel: #1f3a2e;
  --brass-deep: #8a6f2c;
  font-family: "Public Sans", "Inter", ui-sans-serif, sans-serif;
  color: var(--ink);
  background: var(--paper);
  padding: 32px 40px;
  border-radius: 16px;
  border: 1px solid var(--rule);
  position: relative;
}
.legal-journal h1,
.legal-journal h2,
.legal-journal h3 {
  font-family: "Fraunces", "Cormorant Garamond", "EB Garamond", Georgia, serif;
  margin: 0;
}
.legal-journal em {
  font-style: italic;
  font-family: "Fraunces", Georgia, serif;
}
.lj-masthead {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: end;
  gap: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid var(--ink);
}
.lj-meta {
  font-family: "JetBrains Mono", ui-monospace, "SF Mono", monospace;
  font-size: 11px;
  color: var(--ink-mute);
  text-transform: uppercase;
  letter-spacing: 0.04em;
}
.lj-meta-right { text-align: right; }
.lj-meta b { color: var(--ink); font-weight: 600; }
.lj-dot { display: inline-block; width: 7px; height: 7px; background: var(--counsel); border-radius: 50%; margin-right: 6px; vertical-align: 1px; }
.lj-title { text-align: center; font-size: clamp(36px, 6vw, 88px); line-height: 0.9; letter-spacing: -0.018em; font-weight: 350; }
.lj-subhead-rule {
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  gap: 18px;
  align-items: center;
  margin-top: 12px;
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10.5px;
  color: var(--ink-mute);
  text-transform: uppercase;
  letter-spacing: 0.16em;
}
.lj-subhead-rule::before,
.lj-subhead-rule::after { content: ""; height: 1px; background: var(--ink); opacity: 0.5; }
.lj-label {
  font-family: "JetBrains Mono", ui-monospace, monospace;
  font-size: 10px;
  letter-spacing: 0.16em;
  text-transform: uppercase;
  color: var(--ink-faint);
}
.lj-ord {
  font-family: "Fraunces", Georgia, serif;
  font-style: italic;
  font-size: 17px;
}
.lj-standing {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  border-top: 1px solid var(--rule);
  border-bottom: 1px solid var(--rule);
  margin-top: 18px;
  background: var(--paper);
}
.lj-standing-cell { padding: 18px 22px; border-right: 1px solid var(--rule-soft); display: flex; flex-direction: column; gap: 6px; }
.lj-standing-cell:last-child { border-right: 0; }
.lj-standing-value { font-family: "Fraunces", Georgia, serif; font-weight: 360; font-size: 38px; line-height: 1; letter-spacing: -0.02em; color: var(--ink); }
.lj-standing-value sup { font-family: "JetBrains Mono", monospace; font-size: 10px; letter-spacing: 0.04em; color: var(--ink-mute); font-weight: 500; vertical-align: 14px; margin-left: 4px; }
.lj-standing-meta { font-family: "JetBrains Mono", monospace; font-size: 10px; color: var(--ink-faint); letter-spacing: 0.04em; }
.lj-standing-meta b { color: var(--counsel); font-weight: 600; }
.lj-standing-meta.warn b { color: var(--classified); }
.lj-section-head { display: flex; align-items: baseline; gap: 14px; margin: 36px 0 18px; }
.lj-section-head h2 { font-size: 24px; letter-spacing: -0.012em; font-weight: 420; }
.lj-section-head .lj-label { margin-left: auto; }
.lj-dossiers { display: flex; flex-direction: column; gap: 16px; }
.lj-dossier {
  position: relative;
  background: var(--surface);
  border: 1px solid var(--rule);
  padding: 22px 24px 20px;
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 22px;
  align-items: start;
  cursor: pointer;
  transition: transform 0.3s ease, background 0.2s ease, box-shadow 0.3s ease;
}
.lj-dossier:hover { transform: translateY(-2px); background: var(--surface-laid); box-shadow: 0 1px 0 var(--ink), 0 10px 24px -16px rgba(10, 10, 10, 0.45); }
.lj-dossier:focus-visible { outline: 2px solid var(--classified); outline-offset: 3px; }
.lj-dossier-case { font-family: "JetBrains Mono", monospace; font-size: 10.5px; line-height: 1.4; color: var(--ink-mute); letter-spacing: 0.04em; min-width: 124px; border-right: 1px solid var(--rule-soft); padding-right: 18px; }
.lj-dossier-case b { display: block; color: var(--ink); font-size: 13px; font-weight: 600; margin: 4px 0 6px; }
.lj-dossier-age { margin-top: 8px; color: var(--ink-faint); }
.lj-dossier-body { display: flex; flex-direction: column; gap: 6px; }
.lj-dossier-tag { font-family: "JetBrains Mono", monospace; font-size: 9.5px; letter-spacing: 0.18em; text-transform: uppercase; color: var(--counsel); }
.lj-dossier-subject { font-family: "Fraunces", Georgia, serif; font-weight: 420; font-size: 19px; line-height: 1.22; letter-spacing: -0.01em; color: var(--ink); margin: 0; }
.lj-dossier-meta { font-size: 12.5px; color: var(--ink-faint); line-height: 1.5; margin: 0; }
.lj-stamp {
  align-self: start;
  font-family: "JetBrains Mono", monospace;
  font-size: 10.5px;
  font-weight: 600;
  letter-spacing: 0.18em;
  text-transform: uppercase;
  padding: 6px 12px;
  border: 1.5px solid currentColor;
  color: var(--classified);
  white-space: nowrap;
  transform: rotate(-2.5deg);
  line-height: 1;
  background: transparent;
}
.lj-stamp.stamp--filed { color: var(--counsel); }
.lj-stamp.stamp--escalated { color: var(--classified); }
.lj-stamp.stamp--awaiting { color: var(--brass-deep); }
.lj-stamp.stamp--privileged { color: var(--ink); }
.lj-audit-table { width: 100%; border-collapse: collapse; font-family: "Public Sans", "Inter", sans-serif; }
.lj-audit-table th { text-align: left; font-family: "JetBrains Mono", monospace; font-size: 10px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-faint); font-weight: 500; padding: 12px 12px; border-bottom: 1.5px solid var(--ink); border-top: 1px solid var(--ink); background: var(--paper-edge); }
.lj-audit-table td { font-size: 13px; padding: 12px; border-bottom: 1px dotted rgba(10, 10, 10, 0.18); vertical-align: top; line-height: 1.45; }
.lj-audit-table tr:hover td { background: var(--surface-laid); }
.lj-audit-table td.n { font-family: "Fraunces", Georgia, serif; font-style: italic; color: var(--ink-faint); width: 38px; }
.lj-audit-table td.when { font-family: "JetBrains Mono", monospace; font-size: 11.5px; color: var(--ink-mute); white-space: nowrap; }
.lj-audit-table td.who { font-family: "JetBrains Mono", monospace; font-size: 11.5px; color: var(--ink-soft); }
.lj-audit-table td.who b { color: var(--ink); font-weight: 600; }
.lj-audit-table td.what { max-width: 460px; }
.lj-audit-table td.what em { font-family: "Fraunces", Georgia, serif; font-style: italic; color: var(--ink); }
.lj-audit-table td.what .ref { font-family: "JetBrains Mono", monospace; font-size: 10.5px; color: var(--ink-faint); margin-left: 4px; }
.lj-audit-table td.outcome { font-family: "JetBrains Mono", monospace; font-size: 10.5px; letter-spacing: 0.18em; text-transform: uppercase; white-space: nowrap; }
.lj-audit-table td.outcome--filed { color: var(--counsel); }
.lj-audit-table td.outcome--denied { color: var(--classified); }
.lj-audit-table td.outcome--noted { color: var(--brass-deep); }
.lj-drawer { position: fixed; top: 0; right: 0; bottom: 0; width: min(520px, 92vw); background: var(--surface); border-left: 2px solid var(--ink); transform: translateX(100%); transition: transform 0.35s cubic-bezier(0.2, 0.7, 0.2, 1); z-index: 60; overflow-y: auto; box-shadow: -28px 0 64px -32px rgba(10, 10, 10, 0.5); }
.lj-drawer.open { transform: translateX(0); }
.lj-drawer-veil { position: fixed; inset: 0; background: rgba(10, 10, 10, 0.18); backdrop-filter: blur(2px); z-index: 59; }
.lj-drawer-head { padding: 28px 32px 22px; border-bottom: 1.5px solid var(--ink); background: var(--paper-edge); }
.lj-drawer-case { font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.06em; color: var(--ink-mute); text-transform: uppercase; display: flex; justify-content: space-between; align-items: baseline; gap: 12px; }
.lj-drawer-head h2 { font-family: "Fraunces", Georgia, serif; font-weight: 380; font-size: 28px; line-height: 1.05; letter-spacing: -0.015em; margin: 10px 0 0; color: var(--ink); }
.lj-drawer-body { padding: 22px 32px 80px; position: relative; }
.lj-drawer-body section { margin-bottom: 26px; }
.lj-drawer-body h3 { font-family: "JetBrains Mono", monospace; font-size: 10.5px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-faint); font-weight: 500; margin: 0 0 10px; }
.lj-drawer-body p { margin: 0 0 8px; font-size: 13.5px; line-height: 1.6; color: var(--ink-soft); }
.lj-pull { font-family: "Fraunces", Georgia, serif; font-weight: 380; font-style: italic; font-size: 17px; line-height: 1.4; border-left: 2px solid var(--classified); padding-left: 16px; margin: 14px 0 18px; color: var(--ink-soft); }
.lj-kv { display: grid; grid-template-columns: 130px 1fr; gap: 6px 16px; font-size: 12.5px; line-height: 1.6; }
.lj-kv dt { font-family: "JetBrains Mono", monospace; font-size: 10px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-faint); padding-top: 2px; }
.lj-kv dd { margin: 0; color: var(--ink-soft); }
.lj-drawer-actions { display: flex; gap: 10px; margin-top: 8px; flex-wrap: wrap; }
.lj-btn { font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.16em; text-transform: uppercase; padding: 11px 16px; border: 1.25px solid var(--ink); background: var(--paper); color: var(--ink); transition: background 0.2s ease, color 0.2s ease; cursor: pointer; }
.lj-btn:hover:not(:disabled) { background: var(--ink); color: var(--paper); }
.lj-btn-primary { background: var(--ink); color: var(--paper); }
.lj-btn-primary:hover:not(:disabled) { background: var(--classified); border-color: var(--classified); }
.lj-btn-ghost { border-color: rgba(10, 10, 10, 0.25); color: var(--ink-mute); }
.lj-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.lj-drawer-close { position: absolute; top: 22px; right: 24px; font-family: "JetBrains Mono", monospace; font-size: 11px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--ink-mute); padding: 4px 6px; background: transparent; border: 0; cursor: pointer; }
.lj-drawer-close:hover { color: var(--classified); }
.lj-error { color: var(--classified); font-size: 12px; margin-bottom: 8px; }
@media (max-width: 880px) {
  .legal-journal { padding: 24px 18px; }
  .lj-masthead { grid-template-columns: 1fr; text-align: center; }
  .lj-meta-right { text-align: center; }
  .lj-standing { grid-template-columns: repeat(2, 1fr); }
  .lj-standing-cell { border-bottom: 1px solid var(--rule-soft); }
  .lj-dossier { grid-template-columns: 1fr; gap: 14px; }
  .lj-dossier-case { border-right: 0; border-bottom: 1px solid var(--rule-soft); padding: 0 0 12px; }
}
.placeholder\\:text-zinc-600::-moz-placeholder {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.placeholder\\:text-zinc-600::placeholder {
  --tw-text-opacity: 1;
  color: rgb(82 82 91 / var(--tw-text-opacity, 1));
}
.last\\:border-0:last-child {
  border-width: 0px;
}
.hover\\:border-zinc-400:hover {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity, 1));
}
.hover\\:bg-amber-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(180 83 9 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-emerald-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(4 120 87 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-red-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(254 226 226 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-yellow-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(161 98 7 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-zinc-100:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(244 244 245 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-zinc-200:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-zinc-50:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-zinc-700:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(63 63 70 / var(--tw-bg-opacity, 1));
}
.hover\\:bg-zinc-800:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(39 39 42 / var(--tw-bg-opacity, 1));
}
.hover\\:text-red-800:hover {
  --tw-text-opacity: 1;
  color: rgb(153 27 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-red-900:hover {
  --tw-text-opacity: 1;
  color: rgb(127 29 29 / var(--tw-text-opacity, 1));
}
.hover\\:text-zinc-900:hover {
  --tw-text-opacity: 1;
  color: rgb(24 24 27 / var(--tw-text-opacity, 1));
}
.hover\\:text-zinc-950:hover {
  --tw-text-opacity: 1;
  color: rgb(9 9 11 / var(--tw-text-opacity, 1));
}
.hover\\:underline:hover {
  text-decoration-line: underline;
}
.focus\\:border-zinc-400:focus {
  --tw-border-opacity: 1;
  border-color: rgb(161 161 170 / var(--tw-border-opacity, 1));
}
.focus\\:border-zinc-500:focus {
  --tw-border-opacity: 1;
  border-color: rgb(113 113 122 / var(--tw-border-opacity, 1));
}
.active\\:bg-zinc-200:active {
  --tw-bg-opacity: 1;
  background-color: rgb(228 228 231 / var(--tw-bg-opacity, 1));
}
.active\\:bg-zinc-600:active {
  --tw-bg-opacity: 1;
  background-color: rgb(82 82 91 / var(--tw-bg-opacity, 1));
}
.disabled\\:cursor-not-allowed:disabled {
  cursor: not-allowed;
}
.disabled\\:bg-zinc-50:disabled {
  --tw-bg-opacity: 1;
  background-color: rgb(250 250 250 / var(--tw-bg-opacity, 1));
}
.disabled\\:text-zinc-500:disabled {
  --tw-text-opacity: 1;
  color: rgb(113 113 122 / var(--tw-text-opacity, 1));
}
.disabled\\:opacity-50:disabled {
  opacity: 0.5;
}
@media (min-width: 640px) {

  .sm\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .sm\\:flex-row {
    flex-direction: row;
  }

  .sm\\:items-center {
    align-items: center;
  }
}
@media (min-width: 768px) {

  .md\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .md\\:col-span-5 {
    grid-column: span 5 / span 5;
  }

  .md\\:h-\\[430px\\] {
    height: 430px;
  }

  .md\\:w-72 {
    width: 18rem;
  }

  .md\\:w-auto {
    width: auto;
  }

  .md\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .md\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .md\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .md\\:grid-cols-5 {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }

  .md\\:flex-row {
    flex-direction: row;
  }

  .md\\:items-center {
    align-items: center;
  }

  .md\\:justify-between {
    justify-content: space-between;
  }
}
@media (min-width: 1024px) {

  .lg\\:col-span-1 {
    grid-column: span 1 / span 1;
  }

  .lg\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .lg\\:flex {
    display: flex;
  }

  .lg\\:hidden {
    display: none;
  }

  .lg\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .lg\\:p-8 {
    padding: 2rem;
  }
}
@media (min-width: 1280px) {

  .xl\\:col-span-2 {
    grid-column: span 2 / span 2;
  }

  .xl\\:col-span-3 {
    grid-column: span 3 / span 3;
  }

  .xl\\:col-span-4 {
    grid-column: span 4 / span 4;
  }

  .xl\\:col-span-6 {
    grid-column: span 6 / span 6;
  }

  .xl\\:grid-cols-12 {
    grid-template-columns: repeat(12, minmax(0, 1fr));
  }

  .xl\\:grid-cols-2 {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .xl\\:grid-cols-3 {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  .xl\\:grid-cols-4 {
    grid-template-columns: repeat(4, minmax(0, 1fr));
  }

  .xl\\:flex-row {
    flex-direction: row;
  }

  .xl\\:items-center {
    align-items: center;
  }
}
`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc;;AAAd;EAAA,wBAAc;EAAd,wBAAc;EAAd,mBAAc;EAAd,mBAAc;EAAd,cAAc;EAAd,cAAc;EAAd,cAAc;EAAd,eAAc;EAAd,eAAc;EAAd,aAAc;EAAd,aAAc;EAAd,kBAAc;EAAd,sCAAc;EAAd,8BAAc;EAAd,6BAAc;EAAd,4BAAc;EAAd,eAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,kBAAc;EAAd,2BAAc;EAAd,4BAAc;EAAd,sCAAc;EAAd,kCAAc;EAAd,2BAAc;EAAd,sBAAc;EAAd,8BAAc;EAAd,YAAc;EAAd,kBAAc;EAAd,gBAAc;EAAd,iBAAc;EAAd,kBAAc;EAAd,cAAc;EAAd,gBAAc;EAAd,aAAc;EAAd,mBAAc;EAAd,qBAAc;EAAd,2BAAc;EAAd,yBAAc;EAAd,0BAAc;EAAd,2BAAc;EAAd,uBAAc;EAAd,wBAAc;EAAd,yBAAc;EAAd,sBAAc;EAAd,oBAAc;EAAd,sBAAc;EAAd,qBAAc;EAAd;AAAc,CAAd;;CAAc,CAAd;;;CAAc;;AAAd;;;EAAA,sBAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,mBAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,gBAAc;AAAA;;AAAd;;;;;;;;CAAc;;AAAd;;EAAA,gBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gBAAc,EAAd,MAAc;EAAd,cAAc;KAAd,WAAc,EAAd,MAAc;EAAd,0GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,wCAAc,EAAd,MAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,SAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,yCAAc;UAAd,iCAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;EAAA,kBAAc;EAAd,oBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;EAAd,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,mBAAc;AAAA;;AAAd;;;;;CAAc;;AAAd;;;;EAAA,+GAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,+BAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,cAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,cAAc;EAAd,cAAc;EAAd,kBAAc;EAAd,wBAAc;AAAA;;AAAd;EAAA,eAAc;AAAA;;AAAd;EAAA,WAAc;AAAA;;AAAd;;;;CAAc;;AAAd;EAAA,cAAc,EAAd,MAAc;EAAd,qBAAc,EAAd,MAAc;EAAd,yBAAc,EAAd,MAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;EAAA,oBAAc,EAAd,MAAc;EAAd,8BAAc,EAAd,MAAc;EAAd,gCAAc,EAAd,MAAc;EAAd,eAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;EAAd,uBAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;EAAd,SAAc,EAAd,MAAc;EAAd,UAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,oBAAc;AAAA;;AAAd;;;CAAc;;AAAd;;;;EAAA,0BAAc,EAAd,MAAc;EAAd,6BAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,aAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,YAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,6BAAc,EAAd,MAAc;EAAd,oBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,wBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,0BAAc,EAAd,MAAc;EAAd,aAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,kBAAc;AAAA;;AAAd;;CAAc;;AAAd;;;;;;;;;;;;;EAAA,SAAc;AAAA;;AAAd;EAAA,SAAc;EAAd,UAAc;AAAA;;AAAd;EAAA,UAAc;AAAA;;AAAd;;;EAAA,gBAAc;EAAd,SAAc;EAAd,UAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,UAAc;AAAA;;AAAd;;CAAc;;AAAd;EAAA,gBAAc;AAAA;;AAAd;;;CAAc;;AAAd;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;EAAA,UAAc,EAAd,MAAc;EAAd,cAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;AAAA;;AAAd;;CAAc;AAAd;EAAA,eAAc;AAAA;;AAAd;;;;CAAc;;AAAd;;;;;;;;EAAA,cAAc,EAAd,MAAc;EAAd,sBAAc,EAAd,MAAc;AAAA;;AAAd;;CAAc;;AAAd;;EAAA,eAAc;EAAd,YAAc;AAAA;;AAAd,wEAAc;AAAd;EAAA,aAAc;AAAA;AACd;EAAA;AAAoB;AAApB;EAAA;AAAoB;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AAApB;;EAAA;IAAA;EAAoB;;EAApB;IAAA;EAAoB;AAAA;AACpB;EAAA,kBAAmB;EAAnB,UAAmB;EAAnB,WAAmB;EAAnB,UAAmB;EAAnB,YAAmB;EAAnB,gBAAmB;EAAnB,sBAAmB;EAAnB,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,QAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,oBAAmB;EAAnB,4BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;;EAAA;IAAA,mBAAmB;IAAnB;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;;EAAA;IAAA;EAAmB;AAAA;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;OAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,4DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,+DAAmB;EAAnB;AAAmB;AAAnB;EAAA,uBAAmB;EAAnB,8DAAmB;EAAnB;AAAmB;AAAnB;EAAA,wBAAmB;EAAnB,kEAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gBAAmB;EAAnB,uBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,sBAAmB;KAAnB;AAAmB;AAAnB;EAAA,oBAAmB;KAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,gCAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,sBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,qBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,iBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,eAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,mBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA,kBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,kCAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA,oBAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,gDAAmB;EAAnB,6DAAmB;EAAnB;AAAmB;AAAnB;EAAA,0CAAmB;EAAnB,uDAAmB;EAAnB;AAAmB;AAAnB;EAAA,gFAAmB;EAAnB,oGAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,2GAAmB;EAAnB,yGAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;AAAnB;EAAA,6BAAmB;EAAnB;AAAmB;AAAnB;EAAA,wJAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA,8BAAmB;EAAnB,wDAAmB;EAAnB;AAAmB;AAAnB;EAAA;AAAmB;;AAEnB;;;EAGE,YAAY;AACd;;AAEA;EACE;kCACgC;EAChC,mCAAmC;EACnC,kCAAkC;AACpC;;AAEA;6DAC6D;AAC7D;EACE;IACE,UAAU;IACV,mBAAmB;EACrB;EACA;IACE,YAAY;IACZ,sBAAsB;EACxB;AACF;;AAEA;EACE,gEAAgE;AAClE;;AAEA;;;;;;EAME;AACF;EACE,gBAAgB;EAChB,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,mBAAmB;EACnB,mBAAmB;EACnB,oBAAoB;EACpB,eAAe;EACf,kCAAkC;EAClC,qBAAqB;EACrB,kBAAkB;EAClB,qBAAqB;EACrB,8DAA8D;EAC9D,iBAAiB;EACjB,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;EAC7B,kBAAkB;AACpB;AACA;;;EAGE,4EAA4E;EAC5E,SAAS;AACX;AACA;EACE,kBAAkB;EAClB,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,mCAAmC;EACnC,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,mCAAmC;AACrC;AACA;EACE,iEAAiE;EACjE,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA,iBAAiB,iBAAiB,EAAE;AACpC,aAAa,iBAAiB,EAAE,gBAAgB,EAAE;AAClD,UAAU,qBAAqB,EAAE,UAAU,EAAE,WAAW,EAAE,0BAA0B,EAAE,kBAAkB,EAAE,iBAAiB,EAAE,mBAAmB,EAAE;AAClJ,YAAY,kBAAkB,EAAE,iCAAiC,EAAE,gBAAgB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AACjI;EACE,aAAa;EACb,mCAAmC;EACnC,SAAS;EACT,mBAAmB;EACnB,gBAAgB;EAChB,sDAAsD;EACtD,iBAAiB;EACjB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;0BAC0B,WAAW,EAAE,WAAW,EAAE,sBAAsB,EAAE,YAAY,EAAE;AAC1F;EACE,sDAAsD;EACtD,eAAe;EACf,sBAAsB;EACtB,yBAAyB;EACzB,uBAAuB;AACzB;AACA;EACE,uCAAuC;EACvC,kBAAkB;EAClB,eAAe;AACjB;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,iCAAiC;EACjC,oCAAoC;EACpC,gBAAgB;EAChB,wBAAwB;AAC1B;AACA,oBAAoB,kBAAkB,EAAE,wCAAwC,EAAE,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACnI,+BAA+B,eAAe,EAAE;AAChD,qBAAqB,uCAAuC,EAAE,gBAAgB,EAAE,eAAe,EAAE,cAAc,EAAE,uBAAuB,EAAE,iBAAiB,EAAE;AAC7J,yBAAyB,wCAAwC,EAAE,eAAe,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,oBAAoB,EAAE,gBAAgB,EAAE;AAC9L,oBAAoB,wCAAwC,EAAE,eAAe,EAAE,uBAAuB,EAAE,sBAAsB,EAAE;AAChI,sBAAsB,qBAAqB,EAAE,gBAAgB,EAAE;AAC/D,2BAA2B,wBAAwB,EAAE;AACrD,mBAAmB,aAAa,EAAE,qBAAqB,EAAE,SAAS,EAAE,mBAAmB,EAAE;AACzF,sBAAsB,eAAe,EAAE,wBAAwB,EAAE,gBAAgB,EAAE;AACnF,6BAA6B,iBAAiB,EAAE;AAChD,eAAe,aAAa,EAAE,sBAAsB,EAAE,SAAS,EAAE;AACjE;EACE,kBAAkB;EAClB,0BAA0B;EAC1B,6BAA6B;EAC7B,uBAAuB;EACvB,aAAa;EACb,oCAAoC;EACpC,SAAS;EACT,kBAAkB;EAClB,eAAe;EACf,2EAA2E;AAC7E;AACA,oBAAoB,2BAA2B,EAAE,+BAA+B,EAAE,wEAAwE,EAAE;AAC5J,4BAA4B,oCAAoC,EAAE,mBAAmB,EAAE;AACvF,mBAAmB,wCAAwC,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,wCAAwC,EAAE,mBAAmB,EAAE;AACnO,qBAAqB,cAAc,EAAE,iBAAiB,EAAE,eAAe,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AAC9G,kBAAkB,eAAe,EAAE,uBAAuB,EAAE;AAC5D,mBAAmB,aAAa,EAAE,sBAAsB,EAAE,QAAQ,EAAE;AACpE,kBAAkB,wCAAwC,EAAE,gBAAgB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,qBAAqB,EAAE;AACxJ,sBAAsB,uCAAuC,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,iBAAiB,EAAE,SAAS,EAAE;AAC5K,mBAAmB,iBAAiB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,SAAS,EAAE;AAC5F;EACE,iBAAiB;EACjB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,iBAAiB;EACjB,gCAAgC;EAChC,wBAAwB;EACxB,mBAAmB;EACnB,0BAA0B;EAC1B,cAAc;EACd,uBAAuB;AACzB;AACA,yBAAyB,qBAAqB,EAAE;AAChD,6BAA6B,wBAAwB,EAAE;AACvD,4BAA4B,wBAAwB,EAAE;AACtD,8BAA8B,iBAAiB,EAAE;AACjD,kBAAkB,WAAW,EAAE,yBAAyB,EAAE,+CAA+C,EAAE;AAC3G,qBAAqB,gBAAgB,EAAE,wCAAwC,EAAE,eAAe,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,qCAAqC,EAAE,gCAAgC,EAAE,6BAA6B,EAAE;AAC5T,qBAAqB,eAAe,EAAE,aAAa,EAAE,gDAAgD,EAAE,mBAAmB,EAAE,iBAAiB,EAAE;AAC/I,8BAA8B,+BAA+B,EAAE;AAC/D,uBAAuB,uCAAuC,EAAE,kBAAkB,EAAE,uBAAuB,EAAE,WAAW,EAAE;AAC1H,0BAA0B,wCAAwC,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;AACpI,yBAAyB,wCAAwC,EAAE,iBAAiB,EAAE,sBAAsB,EAAE;AAC9G,2BAA2B,iBAAiB,EAAE,gBAAgB,EAAE;AAChE,0BAA0B,gBAAgB,EAAE;AAC5C,6BAA6B,uCAAuC,EAAE,kBAAkB,EAAE,iBAAiB,EAAE;AAC7G,+BAA+B,wCAAwC,EAAE,iBAAiB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AACvI,6BAA6B,wCAAwC,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,mBAAmB,EAAE;AAClK,oCAAoC,qBAAqB,EAAE;AAC3D,qCAAqC,wBAAwB,EAAE;AAC/D,oCAAoC,wBAAwB,EAAE;AAC9D,aAAa,eAAe,EAAE,MAAM,EAAE,QAAQ,EAAE,SAAS,EAAE,uBAAuB,EAAE,0BAA0B,EAAE,iCAAiC,EAAE,2BAA2B,EAAE,0DAA0D,EAAE,WAAW,EAAE,gBAAgB,EAAE,oDAAoD,EAAE;AACjU,kBAAkB,wBAAwB,EAAE;AAC5C,kBAAkB,eAAe,EAAE,QAAQ,EAAE,kCAAkC,EAAE,0BAA0B,EAAE,WAAW,EAAE;AAC1H,kBAAkB,uBAAuB,EAAE,qCAAqC,EAAE,6BAA6B,EAAE;AACjH,kBAAkB,wCAAwC,EAAE,eAAe,EAAE,sBAAsB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,aAAa,EAAE,8BAA8B,EAAE,qBAAqB,EAAE,SAAS,EAAE;AACzO,qBAAqB,uCAAuC,EAAE,gBAAgB,EAAE,eAAe,EAAE,iBAAiB,EAAE,wBAAwB,EAAE,gBAAgB,EAAE,iBAAiB,EAAE;AACnL,kBAAkB,uBAAuB,EAAE,kBAAkB,EAAE;AAC/D,0BAA0B,mBAAmB,EAAE;AAC/C,qBAAqB,wCAAwC,EAAE,iBAAiB,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE,gBAAgB,EAAE;AAClM,oBAAoB,eAAe,EAAE,iBAAiB,EAAE,gBAAgB,EAAE,sBAAsB,EAAE;AAClG,WAAW,uCAAuC,EAAE,gBAAgB,EAAE,kBAAkB,EAAE,eAAe,EAAE,gBAAgB,EAAE,wCAAwC,EAAE,kBAAkB,EAAE,mBAAmB,EAAE,sBAAsB,EAAE;AACxO,SAAS,aAAa,EAAE,gCAAgC,EAAE,aAAa,EAAE,iBAAiB,EAAE,gBAAgB,EAAE;AAC9G,YAAY,wCAAwC,EAAE,eAAe,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,uBAAuB,EAAE,gBAAgB,EAAE;AACrK,YAAY,SAAS,EAAE,sBAAsB,EAAE;AAC/C,qBAAqB,aAAa,EAAE,SAAS,EAAE,eAAe,EAAE,eAAe,EAAE;AACjF,UAAU,wCAAwC,EAAE,eAAe,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,kBAAkB,EAAE,+BAA+B,EAAE,wBAAwB,EAAE,iBAAiB,EAAE,iDAAiD,EAAE,eAAe,EAAE;AAC9R,+BAA+B,sBAAsB,EAAE,mBAAmB,EAAE;AAC5E,kBAAkB,sBAAsB,EAAE,mBAAmB,EAAE;AAC/D,uCAAuC,6BAA6B,EAAE,+BAA+B,EAAE;AACvG,gBAAgB,oCAAoC,EAAE,sBAAsB,EAAE;AAC9E,mBAAmB,YAAY,EAAE,mBAAmB,EAAE;AACtD,mBAAmB,kBAAkB,EAAE,SAAS,EAAE,WAAW,EAAE,wCAAwC,EAAE,eAAe,EAAE,sBAAsB,EAAE,yBAAyB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE,uBAAuB,EAAE,SAAS,EAAE,eAAe,EAAE;AAC5Q,yBAAyB,wBAAwB,EAAE;AACnD,YAAY,wBAAwB,EAAE,eAAe,EAAE,kBAAkB,EAAE;AAC3E;EACE,iBAAiB,kBAAkB,EAAE;EACrC,eAAe,0BAA0B,EAAE,kBAAkB,EAAE;EAC/D,iBAAiB,kBAAkB,EAAE;EACrC,eAAe,qCAAqC,EAAE;EACtD,oBAAoB,yCAAyC,EAAE;EAC/D,cAAc,0BAA0B,EAAE,SAAS,EAAE;EACrD,mBAAmB,eAAe,EAAE,yCAAyC,EAAE,iBAAiB,EAAE;AACpG;AAhOA;EAAA,oBAiOA;EAjOA;AAiOA;AAjOA;EAAA,oBAiOA;EAjOA;AAiOA;AAjOA;EAAA;AAiOA;AAjOA;EAAA,sBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,oBAiOA;EAjOA;AAiOA;AAjOA;EAAA,oBAiOA;EAjOA;AAiOA;AAjOA;EAAA,oBAiOA;EAjOA;AAiOA;AAjOA;EAAA,oBAiOA;EAjOA;AAiOA;AAjOA;EAAA;AAiOA;AAjOA;EAAA,sBAiOA;EAjOA;AAiOA;AAjOA;EAAA,sBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA;AAiOA;AAjOA;EAAA,kBAiOA;EAjOA;AAiOA;AAjOA;EAAA,oBAiOA;EAjOA;AAiOA;AAjOA;EAAA;AAiOA;AAjOA;;EAAA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;AAAA;AAjOA;;EAAA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;AAAA;AAjOA;;EAAA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;AAAA;AAjOA;;EAAA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;;EAjOA;IAAA;EAiOA;AAAA","sourcesContent":["@tailwind base;\n@tailwind components;\n@tailwind utilities;\n\nhtml,\nbody,\n#root {\n  height: 100%;\n}\n\nbody {\n  font-family: \"Instrument Sans\", \"Inter\", ui-sans-serif, system-ui, -apple-system,\n    \"Segoe UI\", Roboto, sans-serif;\n  -webkit-font-smoothing: antialiased;\n  -moz-osx-font-smoothing: grayscale;\n}\n\n/* Sidebar unread-chat badge attention pulse — faster than tailwind's\n   animate-pulse so it reads as urgent rather than ambient. */\n@keyframes pulse-fast {\n  0%, 100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n  50% {\n    opacity: 0.6;\n    transform: scale(1.08);\n  }\n}\n\n.animate-pulse-fast {\n  animation: pulse-fast 1.1s cubic-bezier(0.4, 0, 0.6, 1) infinite;\n}\n\n/* ── Slice F — Office of General Counsel (\"Legal Journal\") ───────────\n * Scoped to `.legal-journal` so the editorial palette (paper / ink /\n * classified red / counsel green / brass) doesn't leak into the rest\n * of the admin portal. Serif headers, monospace labels, dossier cards\n * with a rubber stamp. WCAG-AA: all foreground colors verified ≥ 4.5:1\n * against the paper background.\n */\n.legal-journal {\n  --paper: #f5f1e8;\n  --paper-edge: #ece6d4;\n  --surface: #fffef9;\n  --surface-laid: #fbf6e9;\n  --ink: #0a0a0a;\n  --ink-soft: #1f1f1f;\n  --ink-mute: #3d3d3d;\n  --ink-faint: #5a5648;\n  --rule: #1a1a1a;\n  --rule-soft: rgba(42, 42, 42, 0.2);\n  --classified: #8b0000;\n  --counsel: #1f3a2e;\n  --brass-deep: #8a6f2c;\n  font-family: \"Public Sans\", \"Inter\", ui-sans-serif, sans-serif;\n  color: var(--ink);\n  background: var(--paper);\n  padding: 32px 40px;\n  border-radius: 16px;\n  border: 1px solid var(--rule);\n  position: relative;\n}\n.legal-journal h1,\n.legal-journal h2,\n.legal-journal h3 {\n  font-family: \"Fraunces\", \"Cormorant Garamond\", \"EB Garamond\", Georgia, serif;\n  margin: 0;\n}\n.legal-journal em {\n  font-style: italic;\n  font-family: \"Fraunces\", Georgia, serif;\n}\n.lj-masthead {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  align-items: end;\n  gap: 24px;\n  padding-bottom: 16px;\n  border-bottom: 2px solid var(--ink);\n}\n.lj-meta {\n  font-family: \"JetBrains Mono\", ui-monospace, \"SF Mono\", monospace;\n  font-size: 11px;\n  color: var(--ink-mute);\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n}\n.lj-meta-right { text-align: right; }\n.lj-meta b { color: var(--ink); font-weight: 600; }\n.lj-dot { display: inline-block; width: 7px; height: 7px; background: var(--counsel); border-radius: 50%; margin-right: 6px; vertical-align: 1px; }\n.lj-title { text-align: center; font-size: clamp(36px, 6vw, 88px); line-height: 0.9; letter-spacing: -0.018em; font-weight: 350; }\n.lj-subhead-rule {\n  display: grid;\n  grid-template-columns: 1fr auto 1fr;\n  gap: 18px;\n  align-items: center;\n  margin-top: 12px;\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10.5px;\n  color: var(--ink-mute);\n  text-transform: uppercase;\n  letter-spacing: 0.16em;\n}\n.lj-subhead-rule::before,\n.lj-subhead-rule::after { content: \"\"; height: 1px; background: var(--ink); opacity: 0.5; }\n.lj-label {\n  font-family: \"JetBrains Mono\", ui-monospace, monospace;\n  font-size: 10px;\n  letter-spacing: 0.16em;\n  text-transform: uppercase;\n  color: var(--ink-faint);\n}\n.lj-ord {\n  font-family: \"Fraunces\", Georgia, serif;\n  font-style: italic;\n  font-size: 17px;\n}\n.lj-standing {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  border-top: 1px solid var(--rule);\n  border-bottom: 1px solid var(--rule);\n  margin-top: 18px;\n  background: var(--paper);\n}\n.lj-standing-cell { padding: 18px 22px; border-right: 1px solid var(--rule-soft); display: flex; flex-direction: column; gap: 6px; }\n.lj-standing-cell:last-child { border-right: 0; }\n.lj-standing-value { font-family: \"Fraunces\", Georgia, serif; font-weight: 360; font-size: 38px; line-height: 1; letter-spacing: -0.02em; color: var(--ink); }\n.lj-standing-value sup { font-family: \"JetBrains Mono\", monospace; font-size: 10px; letter-spacing: 0.04em; color: var(--ink-mute); font-weight: 500; vertical-align: 14px; margin-left: 4px; }\n.lj-standing-meta { font-family: \"JetBrains Mono\", monospace; font-size: 10px; color: var(--ink-faint); letter-spacing: 0.04em; }\n.lj-standing-meta b { color: var(--counsel); font-weight: 600; }\n.lj-standing-meta.warn b { color: var(--classified); }\n.lj-section-head { display: flex; align-items: baseline; gap: 14px; margin: 36px 0 18px; }\n.lj-section-head h2 { font-size: 24px; letter-spacing: -0.012em; font-weight: 420; }\n.lj-section-head .lj-label { margin-left: auto; }\n.lj-dossiers { display: flex; flex-direction: column; gap: 16px; }\n.lj-dossier {\n  position: relative;\n  background: var(--surface);\n  border: 1px solid var(--rule);\n  padding: 22px 24px 20px;\n  display: grid;\n  grid-template-columns: auto 1fr auto;\n  gap: 22px;\n  align-items: start;\n  cursor: pointer;\n  transition: transform 0.3s ease, background 0.2s ease, box-shadow 0.3s ease;\n}\n.lj-dossier:hover { transform: translateY(-2px); background: var(--surface-laid); box-shadow: 0 1px 0 var(--ink), 0 10px 24px -16px rgba(10, 10, 10, 0.45); }\n.lj-dossier:focus-visible { outline: 2px solid var(--classified); outline-offset: 3px; }\n.lj-dossier-case { font-family: \"JetBrains Mono\", monospace; font-size: 10.5px; line-height: 1.4; color: var(--ink-mute); letter-spacing: 0.04em; min-width: 124px; border-right: 1px solid var(--rule-soft); padding-right: 18px; }\n.lj-dossier-case b { display: block; color: var(--ink); font-size: 13px; font-weight: 600; margin: 4px 0 6px; }\n.lj-dossier-age { margin-top: 8px; color: var(--ink-faint); }\n.lj-dossier-body { display: flex; flex-direction: column; gap: 6px; }\n.lj-dossier-tag { font-family: \"JetBrains Mono\", monospace; font-size: 9.5px; letter-spacing: 0.18em; text-transform: uppercase; color: var(--counsel); }\n.lj-dossier-subject { font-family: \"Fraunces\", Georgia, serif; font-weight: 420; font-size: 19px; line-height: 1.22; letter-spacing: -0.01em; color: var(--ink); margin: 0; }\n.lj-dossier-meta { font-size: 12.5px; color: var(--ink-faint); line-height: 1.5; margin: 0; }\n.lj-stamp {\n  align-self: start;\n  font-family: \"JetBrains Mono\", monospace;\n  font-size: 10.5px;\n  font-weight: 600;\n  letter-spacing: 0.18em;\n  text-transform: uppercase;\n  padding: 6px 12px;\n  border: 1.5px solid currentColor;\n  color: var(--classified);\n  white-space: nowrap;\n  transform: rotate(-2.5deg);\n  line-height: 1;\n  background: transparent;\n}\n.lj-stamp.stamp--filed { color: var(--counsel); }\n.lj-stamp.stamp--escalated { color: var(--classified); }\n.lj-stamp.stamp--awaiting { color: var(--brass-deep); }\n.lj-stamp.stamp--privileged { color: var(--ink); }\n.lj-audit-table { width: 100%; border-collapse: collapse; font-family: \"Public Sans\", \"Inter\", sans-serif; }\n.lj-audit-table th { text-align: left; font-family: \"JetBrains Mono\", monospace; font-size: 10px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-faint); font-weight: 500; padding: 12px 12px; border-bottom: 1.5px solid var(--ink); border-top: 1px solid var(--ink); background: var(--paper-edge); }\n.lj-audit-table td { font-size: 13px; padding: 12px; border-bottom: 1px dotted rgba(10, 10, 10, 0.18); vertical-align: top; line-height: 1.45; }\n.lj-audit-table tr:hover td { background: var(--surface-laid); }\n.lj-audit-table td.n { font-family: \"Fraunces\", Georgia, serif; font-style: italic; color: var(--ink-faint); width: 38px; }\n.lj-audit-table td.when { font-family: \"JetBrains Mono\", monospace; font-size: 11.5px; color: var(--ink-mute); white-space: nowrap; }\n.lj-audit-table td.who { font-family: \"JetBrains Mono\", monospace; font-size: 11.5px; color: var(--ink-soft); }\n.lj-audit-table td.who b { color: var(--ink); font-weight: 600; }\n.lj-audit-table td.what { max-width: 460px; }\n.lj-audit-table td.what em { font-family: \"Fraunces\", Georgia, serif; font-style: italic; color: var(--ink); }\n.lj-audit-table td.what .ref { font-family: \"JetBrains Mono\", monospace; font-size: 10.5px; color: var(--ink-faint); margin-left: 4px; }\n.lj-audit-table td.outcome { font-family: \"JetBrains Mono\", monospace; font-size: 10.5px; letter-spacing: 0.18em; text-transform: uppercase; white-space: nowrap; }\n.lj-audit-table td.outcome--filed { color: var(--counsel); }\n.lj-audit-table td.outcome--denied { color: var(--classified); }\n.lj-audit-table td.outcome--noted { color: var(--brass-deep); }\n.lj-drawer { position: fixed; top: 0; right: 0; bottom: 0; width: min(520px, 92vw); background: var(--surface); border-left: 2px solid var(--ink); transform: translateX(100%); transition: transform 0.35s cubic-bezier(0.2, 0.7, 0.2, 1); z-index: 60; overflow-y: auto; box-shadow: -28px 0 64px -32px rgba(10, 10, 10, 0.5); }\n.lj-drawer.open { transform: translateX(0); }\n.lj-drawer-veil { position: fixed; inset: 0; background: rgba(10, 10, 10, 0.18); backdrop-filter: blur(2px); z-index: 59; }\n.lj-drawer-head { padding: 28px 32px 22px; border-bottom: 1.5px solid var(--ink); background: var(--paper-edge); }\n.lj-drawer-case { font-family: \"JetBrains Mono\", monospace; font-size: 11px; letter-spacing: 0.06em; color: var(--ink-mute); text-transform: uppercase; display: flex; justify-content: space-between; align-items: baseline; gap: 12px; }\n.lj-drawer-head h2 { font-family: \"Fraunces\", Georgia, serif; font-weight: 380; font-size: 28px; line-height: 1.05; letter-spacing: -0.015em; margin: 10px 0 0; color: var(--ink); }\n.lj-drawer-body { padding: 22px 32px 80px; position: relative; }\n.lj-drawer-body section { margin-bottom: 26px; }\n.lj-drawer-body h3 { font-family: \"JetBrains Mono\", monospace; font-size: 10.5px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-faint); font-weight: 500; margin: 0 0 10px; }\n.lj-drawer-body p { margin: 0 0 8px; font-size: 13.5px; line-height: 1.6; color: var(--ink-soft); }\n.lj-pull { font-family: \"Fraunces\", Georgia, serif; font-weight: 380; font-style: italic; font-size: 17px; line-height: 1.4; border-left: 2px solid var(--classified); padding-left: 16px; margin: 14px 0 18px; color: var(--ink-soft); }\n.lj-kv { display: grid; grid-template-columns: 130px 1fr; gap: 6px 16px; font-size: 12.5px; line-height: 1.6; }\n.lj-kv dt { font-family: \"JetBrains Mono\", monospace; font-size: 10px; letter-spacing: 0.16em; text-transform: uppercase; color: var(--ink-faint); padding-top: 2px; }\n.lj-kv dd { margin: 0; color: var(--ink-soft); }\n.lj-drawer-actions { display: flex; gap: 10px; margin-top: 8px; flex-wrap: wrap; }\n.lj-btn { font-family: \"JetBrains Mono\", monospace; font-size: 11px; letter-spacing: 0.16em; text-transform: uppercase; padding: 11px 16px; border: 1.25px solid var(--ink); background: var(--paper); color: var(--ink); transition: background 0.2s ease, color 0.2s ease; cursor: pointer; }\n.lj-btn:hover:not(:disabled) { background: var(--ink); color: var(--paper); }\n.lj-btn-primary { background: var(--ink); color: var(--paper); }\n.lj-btn-primary:hover:not(:disabled) { background: var(--classified); border-color: var(--classified); }\n.lj-btn-ghost { border-color: rgba(10, 10, 10, 0.25); color: var(--ink-mute); }\n.lj-btn:disabled { opacity: 0.5; cursor: not-allowed; }\n.lj-drawer-close { position: absolute; top: 22px; right: 24px; font-family: \"JetBrains Mono\", monospace; font-size: 11px; letter-spacing: 0.12em; text-transform: uppercase; color: var(--ink-mute); padding: 4px 6px; background: transparent; border: 0; cursor: pointer; }\n.lj-drawer-close:hover { color: var(--classified); }\n.lj-error { color: var(--classified); font-size: 12px; margin-bottom: 8px; }\n@media (max-width: 880px) {\n  .legal-journal { padding: 24px 18px; }\n  .lj-masthead { grid-template-columns: 1fr; text-align: center; }\n  .lj-meta-right { text-align: center; }\n  .lj-standing { grid-template-columns: repeat(2, 1fr); }\n  .lj-standing-cell { border-bottom: 1px solid var(--rule-soft); }\n  .lj-dossier { grid-template-columns: 1fr; gap: 14px; }\n  .lj-dossier-case { border-right: 0; border-bottom: 1px solid var(--rule-soft); padding: 0 0 12px; }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
